import React, { useMemo, useState } from 'react';

function ClinicSettingsNav({ tabs, activeTab, onTabChange }) {
    const [isOpen, setIsOpen] = useState(true);

    const activeLabel = useMemo(
        () => tabs.find((tab) => tab.id === activeTab)?.label || 'General',
        [tabs, activeTab]
    );

    return (
        <div className={`ecx-page-card ecx-page-panel clinic-settings-nav${isOpen ? '' : ' clinic-settings-nav--collapsed'}`}>
            <div className="ecx-page-panel__header clinic-settings-nav__header">
                <button
                    type="button"
                    className="clinic-settings-nav__toggle d-lg-none"
                    onClick={() => setIsOpen((open) => !open)}
                    aria-expanded={isOpen}
                    aria-controls="clinic-settings-nav-body"
                >
                    <div className="d-flex align-items-center gap-2 min-width-0">
                        <span className="ecx-page-icon-badge" style={{ width: '2rem', height: '2rem' }}>
                            <i className="bi bi-sliders"></i>
                        </span>
                        <div className="text-start min-width-0">
                            <h6 className="mb-0 fw-semibold">Settings</h6>
                            {!isOpen && (
                                <span className="clinic-settings-nav__active small text-muted text-truncate d-block">
                                    {activeLabel}
                                </span>
                            )}
                        </div>
                    </div>
                    <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} clinic-settings-nav__chevron`}></i>
                </button>

                <div className="d-none d-lg-flex align-items-center gap-2">
                    <span className="ecx-page-icon-badge" style={{ width: '2rem', height: '2rem' }}>
                        <i className="bi bi-sliders"></i>
                    </span>
                    <h6 className="mb-0 fw-semibold">Settings</h6>
                </div>
            </div>

            <div id="clinic-settings-nav-body" className="ecx-page-panel__body ecx-page-scroll clinic-settings-nav__body">
                <div className="clinic-settings-nav__list">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            className={`clinic-settings-nav__item ${
                                activeTab === tab.id ? 'is-active' : ''
                            }`}
                            onClick={() => onTabChange(tab.id)}
                        >
                            <span className="clinic-settings-nav__item-icon">
                                <i className={`bi ${tab.icon}`}></i>
                            </span>
                            <span className="clinic-settings-nav__item-label">{tab.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ClinicSettingsNav;
